import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { ToastModule } from 'primeng/toast';
import { map } from 'rxjs';

@Component({
  selector: 'app-edit-fdid',
  imports: [MatProgressSpinnerModule, CommonModule, ButtonModule, MatTooltipModule, DrawerModule, FormsModule, DialogModule,
    CheckboxModule, ToastModule],
  templateUrl: './edit-fdid.component.html',
  styleUrl: './edit-fdid.component.scss',
})
export class EditFdidComponent {
  @Input('selectedFDIDData') selectedFDIDData: any;
  @Input() displaySideBar!: boolean;
  @Input() autoCopied!: boolean;
  @Input() DefaultFilterArray: any;
  @Input() Limit: any
  @Output() closeSideBar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() refreshData: EventEmitter<boolean> = new EventEmitter<boolean>();
  checked: boolean = false;
  FDIDDetails: any;
  isLoadingResults: boolean = false;

  constructor(private sharedHttpClientService: SharedHttpClientService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private urlService: UrlsService,
    private gridService: GridService,) { }
  ngOnInit() {
    if (this.selectedFDIDData) {
      this.FDIDDetails = { ...this.selectedFDIDData };
    }
  }

  onClickClose(boolean: any) {
    this.closeSideBar.emit(boolean);
    this.displaySideBar = false;
  }

  onUpdate(editForm: NgForm) {
 const receivedFdidContol = editForm.controls['receivedFDID'];
    if(this.FDIDDetails["generatedFDID"]){
      this.FDIDDetails["receivedFDID"] = this.FDIDDetails["generatedFDID"];
      if(receivedFdidContol){
        receivedFdidContol.setValue(this.FDIDDetails.generatedFDID);
        receivedFdidContol.markAsDirty();
        receivedFdidContol.updateValueAndValidity();
      }
    }
    if (editForm.invalid) {
      editForm.form.markAllAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation Error',
        detail: 'Please fill all required fields correctly'
      });
      return;
    }
    else {
      let payload = {
        "CATReporterIMID": this.userService.getActiveMPID(),
        "accountNumber": this.FDIDDetails["accountNumber"],
        "name": this.FDIDDetails["name"],
        "givenName": this.FDIDDetails["givenName"],
        "generatedFDID": this.FDIDDetails["generatedFDID"],
        "receivedFDID": this.FDIDDetails["receivedFDID"],
        "UpdatedUser": this.userService.getUserFirstName(),
        "oldGeneratedFDID":this.selectedFDIDData["generatedFDID"],
        "oldAccountNumber": this.selectedFDIDData["accountNumber"],
        "oldName": this.selectedFDIDData["name"],
        "oldGivenName": this.selectedFDIDData["givenName"],
        "id":this.FDIDDetails["id"]
      }
      this.sharedHttpClientService.post(this.urlService.setAPIURl(APIURL.CAT_FDID_Edit), payload)
        .pipe(map((response: Response) => {
          return response;
        }))
        .subscribe({
          next: (dataset: any) => {
            this.refreshData.emit(true);
            this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Record Updated' });
            this.userService.logUserActivity("Record Updated", null, {
            'Text1': this.userService.userFirstName + ' CAT FDID Record Updated',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
    });
          },
          error: (err: HttpErrorResponse) => {
            this.isLoadingResults = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Record Not Found' });
          }
        });
    }
  }

  onReceivedFDIDChange(event: any) {
    if (event) {
      this.FDIDDetails.generatedFDID = event;
    }
    else {
      this.FDIDDetails.generatedFDID = '';
    }
  }
  onKeyFieldChanges() {
    if (this.autoCopied && this.FDIDDetails.generatedFDID) {
      this.FDIDDetails.receivedFDID = this.FDIDDetails.generatedFDID;
    }

  }
}
